/** The MCP sidebar row's words, and the no-server reason the MCP row and the Build with Claude row share. */

export const MCP_ROW_LABEL = "MCP";
export const MCP_ROW_OFF_LABEL = "MCP, not available";
export const MCP_NOT_AVAILABLE = "Not available";
export const NO_MCP = "This deployment has no MCP server.";
